import React from 'react'
import './Game.css'
import {Deck} from './Deck/Deck'
import {concat, removeItem, shuffle} from '../../utils/Array'
import {Confirm, ConfirmProps} from '../Confirm/Confirm'
import {Status} from './Status'
import getCardSize from '../../helpers/getCardSize'
import {TrumpLabel} from './TrumpLabel'
import debounce from 'lodash.debounce'
import throttle from 'lodash.throttle'
import {getProtectionCards} from './Deck/Card/getProtectionCards'
import {Card, checkAttack, compareCards, getMinTrump} from '../../utils/Deck'
import {DESC_MAX_WIDTH, FAST_MODE, appStorage} from '../../common'
import {playClickSound, playSlideSoundEffect, playCardSoundEffect} from '../../common'
import {random, randomItem} from '../../utils'
import {Cat} from './Cat/Cat'
import {Deck as DeckUtil} from '../../utils/Deck/Deck'
import {WinAnimation} from './WinAnimation/WinAnimation'
import {isMobile} from '../../helpers/isMobile'

export enum Winner {
    None = '',
    User = 'user',
    Rival = 'rival',
    Draw = 'draw',
}

type GameProps = {
    hideBaldaCards: boolean
    onStart?: Function
    onComplete?: Function
    onMove?: Function
    onVisitParams?: Function
    onEndBattle?: Function
    onCloseConfirm?: Function
    mute?: boolean
    lang: string
}

export type CardProps = {
    key: string
    width?: number
    height?: number
    left?: number
    top?: number
    rotate?: number
    active?: boolean
    flip?: boolean
    z?: number
    index: number
    deck?: boolean // TRUE для карты лежащей в колоде
}

enum confirmTypes {
    BEAT, // Бито
    BEAT_WITH_HINT, // Бито
    NEED_TAKE, // Игрок берет
    BALDA_TAKE, // Балда берет
    PLAY_YET, // Играть еще
    BALDA_TAKE_WITH_HINT,
}

type GameState = {
    userCards: string[]
    rivalCards: string[]
    battleCards: string[][]
    trump: string
    offset: number
    turn?: Winner
    gameStarted: boolean
    animatedKeys: string[]
    winner?: Winner
    cat: number
    cards: CardProps[]
    confirm: ConfirmProps & {type?: confirmTypes}
    winAnimation: boolean
}

const GAME_IN_PROGRESS_KEY = 'GAME_IN_PROGRESS'

const DeckUtilInst = DeckUtil.getInstance()

const getCardByKey = (key: string): Card => DeckUtilInst.getCardByKey(key)

const getIndexByKey = (key: string): number => DeckUtilInst.getIndexByKey(key)

export class Game extends React.Component<GameProps, GameState> {
    private showGiveUpConfirmTID: any
    private readonly baldaAttackTID: any
    private moveDisabled: boolean
    private disableNewGameBtn: boolean

    private readonly onResize: () => void

    constructor(props: GameProps) {
        super(props)
        this.state = {
            userCards: [],
            rivalCards: [],
            battleCards: [],
            confirm: {},
            trump: 'QS',
            offset: 0,
            gameStarted: false,
            animatedKeys: [],
            cat: 0,
            cards: DeckUtilInst.getShuffledKeys().map((key, index) => ({
                key,
                index,
            })),
            winAnimation: false,
        }
        this.showGiveUpConfirmTID = 0
        this.baldaAttackTID = 0
        this.moveDisabled = false
        let resize = debounce(this.resize, 25)
        this.onResize = () => resize.call(this)
        this.disableNewGameBtn = false
    }

    render(): JSX.Element {
        let {gameStarted, battleCards, confirm, winAnimation} = this.state
        let {turn, animatedKeys, trump, offset, cat, cards} = this.state
        let trumpSuit = getCardByKey(trump).suit

        if (cat === 3) {
            this.params('Котик')
            appStorage.upd({catFound: true})
        }
        return (
            <div className="Game">
                <Status
                    gameStarted={gameStarted}
                    onClickStart={() => this.newGame()}
                    countBattleCards={battleCards.length}
                    turn={turn}
                    lang={this.props.lang}
                />
                <Deck
                    cards={cards}
                    onClick={(key: string) => this.onClick(key)}
                    fast={FAST_MODE}
                    animatedKeys={animatedKeys}
                    lang={this.props.lang}
                />
                <Confirm {...confirm} top={Game.confirmTop()} onClick={(index: number) => this.onConfirm(index)} />
                {offset >= 36 && <TrumpLabel suit={trumpSuit} lang={this.props.lang} />}
                {cat >= 3 && <Cat />}
                {winAnimation && <WinAnimation onClick={() => this.setState({winAnimation: false})} />}
            </div>
        )
    }

    componentDidUpdate(prevProps: Readonly<GameProps>, prevState: Readonly<GameState>, snapshot?: any): void {
        let {hideBaldaCards} = this.props

        if (hideBaldaCards !== prevProps.hideBaldaCards) {
            let {rivalCards} = this.state
            let cards = this.state.cards.slice(0)

            for (let i = 0; i < rivalCards.length; i++) {
                let key = rivalCards[i]
                let index = DeckUtilInst.getIndexByKey(key)
                cards[index].flip = !hideBaldaCards
            }
            this.setState({cards})
        }
    }

    componentDidMount(): void {
        if (FAST_MODE) {
            this.newGame()
        }
        if (process.env.NODE_ENV === 'development') {
            // @ts-ignore
            window.historyState = []
            window.addEventListener('keyup', async e => {
                if (e.key === 's') {
                    let state = JSON.stringify(this.state)
                    console.log(`window.setState(${state})`)
                } else if (e.key === 'z' && e.ctrlKey) {
                    // @ts-ignore
                    if (window.historyState.length) {
                        // @ts-ignore
                        let state = window.historyState.pop()
                        console.log(`window.setState(${state})`)
                        // @ts-ignore
                        window.setState(state)
                        this.onResize()
                        await this.timeout(500)

                        if (this.state.turn === Winner.Rival) {
                            this.onMove().then(() => {})
                        }
                    } else {
                        console.log('Нет ходов в истории')
                    }
                } else if (e.key === 'w') {
                    let series = Game.updateStat(Winner.User)
                    console.log('Win (debug updateStat) series:', series)
                } else if (e.key === 'l') {
                    let series = Game.updateStat(Winner.Rival)
                    console.log('Loss (debug updateStat) series:', series)
                } else if (e.key === 'd') {
                    let series = Game.updateStat(Winner.Draw)
                    console.log('Draw (debug updateStat) series:', series)
                } else if (e.key === 'r') {
                    appStorage.upd({
                        win: 0,
                        loss: 0,
                        draw: 0,
                        series: 0,
                        maxSeries: 0,
                    })
                    // alert('Статистика сброшена')
                }
            })
            // @ts-ignore
            window.setState = json => {
                this.setState(json, () => {
                    let keys = json.cards.map((c: any) => c.key)
                    DeckUtilInst.setKeys(keys)

                    if (this.props.onStart) {
                        this.props.onStart()
                    }
                    if (json.turn && json.turn === Winner.Rival) {
                        this.onMove()
                    }
                    this.onResize()
                })
            }
            let json = ''

            if (json) {
                // @ts-ignore
                window.setState(JSON.parse(json))
            }
            if (window.location.search.indexOf('?state=') !== -1) {
                fetch('/yandex/durak/state' + window.location.search, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                    .then(res => res.json())
                    .then(res => {
                        if (res && res.state) {
                            console.log(res.key)
                            // @ts-ignore
                            window.setState(res.state)
                        }
                    })
            }
        }
        window.addEventListener('resize', this.onResize)
        console.log('stat:', appStorage.get())
        this.onResize()
    }

    componentWillUnmount(): void {
        window.removeEventListener('resize', this.onResize)
    }

    private static confirmTop(): number {
        const {innerWidth, innerHeight} = window

        if (isMobile() && innerHeight > innerWidth) {
            // iphone X
            if (innerHeight / innerWidth > 2) {
                return innerHeight - 2.9 * getCardSize().height
            }
            return Math.ceil(getCardSize().height * 1.2)
        }
        return getCardSize().height
    }

    public async newGame(): Promise<void> {
        if (this.disableNewGameBtn) {
            return
        }
        this.disableNewGameBtn = true

        this.cancelScheduledConfirms()
        if (!this.props.mute) {
            playClickSound()
        }
        this.params('Новая игра')
        this.playSlideSoundEffect()
        let interval = 16
        await this.hideConfirm()
        let cards = DeckUtilInst.getShuffledKeys()
        await this.setStateAsync({
            userCards: [],
            rivalCards: [],
            battleCards: [],
            offset: 0,
            gameStarted: true,
            turn: Winner.None,
            winner: Winner.None,
            cards: cards.map((key, index) => ({
                key,
                index,
                left: this.state.cards[index].left,
                top: this.state.cards[index].top,
                active: false,
                flip: false,
            })),
            confirm: {},
            winAnimation: false,
            animatedKeys: [],
        })
        await this.timeout(100)
        this.cancelScheduledConfirms()
        await this.moveCardsToCenter()
        await this.shuffleAnimation()
        await this.timeout(500)
        let [userCards, rivalCards] = await this.handOverCards(5 * interval)
        await this.timeout()
        await this.moveDeckToRight()
        let trump = this.handOverTrump()
        this.setState({
            trump: trump,
            userCards: userCards,
            rivalCards: rivalCards,
            offset: 12,
            confirm: {},
        })
        await this.timeout()
        this.alignUserCards(userCards)
        this.alignBaldaCards(rivalCards)
        let turn = Game.getGameStarter(userCards, rivalCards, trump)
        this.setState({turn: turn, confirm: {}}, () => {
            if (turn === Winner.Rival) {
                this.onMove()
            }
        })
        if (this.props.onStart) {
            this.props.onStart()
        }
        if (localStorage.getItem(GAME_IN_PROGRESS_KEY)) {
            console.log('Сброс числа побед подряд')
            appStorage.upd({series: 0})
            localStorage.removeItem(GAME_IN_PROGRESS_KEY)
        }
        this.disableNewGameBtn = false
    }

    private cancelScheduledConfirms(): void {
        if (this.showGiveUpConfirmTID) {
            clearTimeout(this.showGiveUpConfirmTID)
        }
        if (this.baldaAttackTID) {
            clearTimeout(this.baldaAttackTID)
        }
    }

    private async shuffleAnimation(): Promise<void> {
        let cards = this.state.cards.slice(0)
        let left = cards[0].left || 0
        const {width} = getCardSize()

        await this.timeout(500)
        this.playSlideSoundEffect()

        let indexes = shuffle(Array.from({length: 36}, (_, i) => i))

        for (let i of indexes) {
            let card = cards[i]

            if (i < 18) {
                card.left = left - 1.5 * width
            } else {
                card.left = left + 1.5 * width
            }
            await this.setStateAsync({cards})
            await this.timeout(16)
        }
        await this.timeout(1000)
        this.playSlideSoundEffect()

        for (let i of indexes) {
            let card = cards[i]
            card.left = left
            card.rotate = random(-30, 30)
            await this.setStateAsync({cards})
            await this.timeout(16)
        }
        await this.timeout(1000)

        for (let i = 0; i < cards.length; i++) {
            let card = cards[i]
            card.rotate = 0
            await this.setStateAsync({cards})
        }
        await this.timeout(500)
    }

    private resize(): void {
        const {offset, userCards, rivalCards} = this.state

        if (offset >= 12) {
            this.alignDeck()
            this.alignUserCards(userCards)
            this.alignBaldaCards(rivalCards)
            this.alignBattleCards()
        } else {
            const {innerWidth} = window
            const width = Math.min(innerWidth, DESC_MAX_WIDTH)
            const left = (innerWidth - width) / 2 + (innerWidth > DESC_MAX_WIDTH ? 0 : 10)
            let cards = this.state.cards.slice(0)
            for (let i = 0; i < cards.length; i++) {
                cards[i].left = left
            }
            this.setState({cards})
        }
    }

    private async moveCardsToCenter(): Promise<void> {
        const {width, height} = getCardSize()
        const left = Math.round(Game.getMaxWidth() / 2 - width / 2)
        const top = Math.round(window.innerHeight / 2 - height / 2)
        let {cards} = this.state

        cards = cards.map((card: CardProps, i: number) => {
            return {
                ...card,
                width,
                height,
                left,
                top,
                flip: false,
                rotate: 0,
                z: i,
                active: false,
            }
        })
        this.setState({cards})
    }

    private async handOverCards(interval: number = 16): Promise<string[][]> {
        return Promise.all([this.handOverUserCards(interval), this.handOverRivalCards(interval)])
    }

    private async handOverUserCards(interval: number = 16): Promise<string[]> {
        let cardSize = getCardSize()
        let left = Game.getLeftPadding()
        let top = window.innerHeight - cardSize.height - 10
        let cards = this.state.cards.slice(0)

        for (let i = 0; i < 6; i++) {
            let card = cards[i]
            card.left = left
            card.top = top
            card.active = true
            await this.setStateAsync({cards})
            await this.timeout(interval)
            this.playCardSoundEffect()
        }
        return cards.slice(0, 6).map(c => c.key)
    }

    private async handOverRivalCards(interval: number = 16): Promise<string[]> {
        let left = Game.getLeftPadding()
        let cards = this.state.cards.slice(0)

        for (let i = 6; i < 12; i++) {
            let card = cards[i]
            card.left = left
            card.top = 10
            card.active = false
            await this.setStateAsync({cards})
            await this.timeout(interval)
            this.playCardSoundEffect()
        }
        return cards.slice(6, 12).map(c => c.key)
    }

    private async alignUserCards(cards: string[], missingCards?: string[]): Promise<void> {
        const cardSize = getCardSize()
        let dy: number = 20
        const {innerWidth, innerHeight} = window
        const stepLeft = Game.getLeftStep(cards.length)
        const leftPadding = Game.getLeftPadding(cards.length)

        if (isMobile() && innerWidth > innerHeight) {
            dy = 5
        }
        await this.leftAlignCards(
            cards,
            (card: CardProps, i: number) => {
                const {y, a} = Game.alignGard(cards.length, i)
                const left = i * stepLeft + 10 + leftPadding
                const top = innerHeight - cardSize.height - dy
                card.left = left
                card.top = top - y
                card.rotate = -a
                card.z = i
                card.flip = true
                card.active = true
                card.deck = false
            },
            missingCards
        )
    }

    private async alignBaldaCards(cards: string[], missingCards?: string[]): Promise<void> {
        const {innerWidth, innerHeight} = window
        const stepLeft = Game.getLeftStep(cards.length)
        const leftPadding = Game.getLeftPadding(cards.length)
        let dy = 15

        if (isMobile() && innerWidth < 900) {
            dy = 35
        }
        if (isMobile() && innerWidth > innerHeight) {
            dy = 5
        }
        await this.leftAlignCards(
            cards,
            (card: CardProps, i: number) => {
                const {y, a} = Game.alignGard(cards.length, i)
                const left = i * stepLeft + 10 + leftPadding
                const top = y + dy
                card.left = left
                card.top = top
                card.rotate = a
                card.z = i
                card.flip = !this.props.hideBaldaCards
                card.deck = false
            },
            missingCards
        )
    }

    private static getLeftStep(countCards: number): number {
        const leftPadding = Game.getLeftPadding(countCards)
        const cardSize = getCardSize()
        let {innerWidth} = window
        let stepLeft = Math.floor(innerWidth - 50 - leftPadding) / countCards
        stepLeft = Math.min(stepLeft, (cardSize.width / 3) * 2)
        return stepLeft
    }

    // Веер (угол наклона и смещение по вертикали)
    private static alignGard(countCards: number, index: number): {y: number; a: number} {
        if (countCards > 2) {
            const dy = 20
            const x = (1 / (countCards - 1)) * index * Math.PI
            const y = Math.round(Math.sin(x) * dy)
            const a = Math.round(Math.cos(x) * 10)
            return {y, a}
        }
        return {y: 0, a: 0}
    }

    private async leftAlignCards(handCards: string[], fn: Function, missingCards?: string[]): Promise<void> {
        handCards = this.sortCardsByWeight(handCards.slice())
        let cards = this.state.cards.slice()

        for (let i = 0; i < handCards.length; i++) {
            let key = handCards[i]
            let index = getIndexByKey(key)
            let card = cards[index]

            fn(card, i)

            if (missingCards) {
                await this.setStateAsync({cards})

                if (missingCards.indexOf(key) !== -1) {
                    this.playCardSoundEffect()
                    await this.timeout(100)
                }
            }
        }
        if (!missingCards) {
            await this.setStateAsync({cards})
        }
    }

    private async moveDeckToRight(offset: number = 12): Promise<void> {
        let {width, height} = getCardSize()
        let left = Game.getMaxWidth() - width / 2 + Game.getLeftPadding()
        let top = Math.round(window.innerHeight / 2 - height / 2)
        let cards = this.state.cards.slice(0)
        let k = window.innerWidth < 500 || isMobile() ? 0.5 : 1
        let count = cards.length - offset

        for (let i = offset; i < cards.length; i++) {
            let card = cards[i]
            let deltaX = (i - offset) * k
            let deltaY = (count - (i - offset)) * k
            card.left = left - deltaX
            card.top = top - deltaY + (window.innerWidth < 650 ? 5 : 0)
            card.rotate = -5
            card.flip = i === 35 // предотвращение перерисовок главного козыря
            card.z = 50 - i
            card.deck = true
        }
        if (offset === 12 && this.disableNewGameBtn) {
            this.playSlideSoundEffect()
        }
        await this.setStateAsync({cards})
    }

    private handOverTrump(): string {
        let {width, height} = getCardSize()
        let cards = this.state.cards.slice(0)
        let trump = cards.pop()
        let left = Game.getMaxWidth() - width - 20 + Game.getLeftPadding()
        let top = Math.round(window.innerHeight / 2 - height / 2) + 10

        if (trump) {
            trump.rotate = -95
            trump.left = left
            trump.top = top
            trump.flip = true
            trump.z = 1
            cards.push(trump)
            this.setState({cards})
            return trump.key
        }
        return ''
    }

    // Пользователь
    private async onClick(key: string): Promise<void> {
        const {userCards, turn, cat, winner, offset} = this.state

        if (winner) {
            console.log('Игра завершена')
            return
        }
        if (offset === 0) {
            console.log('Игра еще не началась')
            this.setState({cat: cat + 1})
            return
        }
        if (this.moveDisabled) {
            console.log('moveDisabled')
            return
        }
        if (userCards && userCards.indexOf(key) !== -1) {
            // Игрок ходит под балду
            if (turn === Winner.User) {
                this.userAttackMove(key)
            } else {
                // Игрок отбивается
                this.userProtection(key)
            }
            if (offset > 15) {
                localStorage.setItem(GAME_IN_PROGRESS_KEY, '1')
            }
        } else {
            if (turn === Winner.Rival && this.getBattleCards().indexOf(key) !== -1) {
                // Ускоренное отображение предложения взять карты при кликах
                this.showGiveUpConfirm(0)
            } else {
                this.showCard(key)
            }
        }
    }

    private showCard = throttle(async (key: string) => {
        let index = DeckUtilInst.getIndexByKey(key)

        if (index >= this.state.offset && index !== 35) {
            const isTopCard = index === this.state.offset

            await this.modifyCards([key], (card: CardProps) => {
                let {left, top} = card

                if (!card || !left || !top) {
                    return card
                }
                if (index !== 34 && !isTopCard) {
                    card = {
                        ...card,
                        rotate: -30,
                        left: left - 30,
                        top: top - 20,
                    }
                }
                return {...card, flip: true}
            })
            await this.timeout(isTopCard ? 800 : 1000)
            this.alignDeck()
            this.params('Подсматривание карты')
        } else if (
            this.getBattleCards().indexOf(key) !== -1 ||
            (this.state.rivalCards.indexOf(key) !== -1 && !this.props.hideBaldaCards)
        ) {
            await this.modifyCards([key], (card: CardProps) => {
                return {...card, z: (card.z || 0) + 100}
            })
            await this.timeout(400)
            await this.modifyCards([key], (card: CardProps) => {
                return {...card, z: (card.z || 0) % 100}
            })
        }
    }, 1000)

    private async modifyCards(keys: string[], fn: Function): Promise<void> {
        let cards = this.state.cards.slice(0)

        for (let i = 0; i < keys.length; i++) {
            let key = keys[i]
            let index = DeckUtilInst.getIndexByKey(key)
            cards[index] = fn(cards[index], key, index, i)
        }
        return this.setStateAsync({cards})
    }

    private userAttackMove(card: string): void {
        let {userCards, rivalCards, battleCards} = this.state
        battleCards = battleCards.slice()
        userCards = userCards.slice()

        if (this.checkCard(card, rivalCards)) {
            this.playCardSoundEffect()
            this.moveDisabled = true
            battleCards.push([card])
            userCards = removeItem(userCards, card)
            this.setState(
                {
                    battleCards: battleCards,
                    userCards: userCards,
                    animatedKeys: [],
                },
                () => {
                    this.moveDisabled = false
                    setImmediate(() => this.alignBattleCards())
                    this.checkWin()
                    this.onMove().then()
                }
            )
        } else {
            console.log('Нет таких карт')
        }
    }

    private userProtection(card: string): void {
        const move = this.protectionMove(card)

        if (move === -1) {
            console.log('Этой картой ни чего не покрыть')
        } else {
            if (this.showGiveUpConfirmTID) {
                clearTimeout(this.showGiveUpConfirmTID)
            }
            let battleCards = this.state.battleCards.slice(0)
            battleCards[move].push(card)
            this.setState(
                {
                    userCards: removeItem(this.state.userCards, card),
                    battleCards: battleCards,
                    animatedKeys: [],
                },
                () => {
                    setImmediate(() => this.alignBattleCards())
                    this.onMove().then()
                    this.checkWin()
                }
            )
            this.playCardSoundEffect()
        }
    }

    private log(): void {
        if (process.env.NODE_ENV === 'development' && window.location.search.indexOf('?state=') === -1) {
            let {hostname, port} = window.location

            fetch('http://' + hostname + ':' + port + '/yandex/durak/state', {
                method: 'POST',
                body: JSON.stringify(this.state),
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(res => res.json())
                .then(res => {
                    console.log('%c%s', 'color: green', `state saved http://localhost:3000/?state=${res.key}`)
                })
        }
    }

    // Ищет карту, которую можно покрыть переданной картой "card"
    private protectionMove(card: string): number {
        const {battleCards, trump} = this.state

        for (let i = 0; i < battleCards.length; i++) {
            let battleItem = battleCards[i]

            if (battleItem.length === 1) {
                if (compareCards(getCardByKey(battleItem[0]), getCardByKey(card), getCardByKey(trump))) {
                    return i
                }
            }
        }
        return -1
    }

    private checkWin(): void {
        const winner = this.getWinner()
        const {mute, hideBaldaCards} = this.props

        if (winner && !this.state.winner) {
            this.playCompleteWin(winner)
            let winAnimation = winner === Winner.User
            this.setState({winner, winAnimation})
            let series = Game.updateStat(winner)
            this.params({
                'Конец игры': {['Победитель: ' + winner]: 1},
                ['Карты балды ' + (hideBaldaCards ? 'скрыты' : 'открыты')]: 1,
                [mute ? 'Игра без звука' : 'Игра со звуком']: {
                    [isMobile() ? 'Мобильные' : 'Десктоп']: 1,
                },
                'Беспроигрышные серии': {
                    [series + ' побед']: 1,
                },
                'Выигрыш с погонами': this.shoulderStraps() ? 1 : 0,
            })
        }
    }

    private static updateStat(winner: string): number {
        let {win, loss, draw, series, maxSeries} = appStorage.get()

        switch (winner) {
            case Winner.User:
                win += 1
                series += 1
                maxSeries = Math.max(maxSeries, series)
                break
            case Winner.Rival:
                loss += 1
                series = 0
                break
            case Winner.Draw:
                draw += 1
                series = 0
                break
        }
        appStorage.upd({win, loss, draw, series, maxSeries})
        localStorage.removeItem(GAME_IN_PROGRESS_KEY)
        console.log('stat:', appStorage.get())
        return series
    }

    private getWinner(): Winner {
        const {offset, userCards, rivalCards} = this.state

        if (offset >= this.state.cards.length) {
            if (userCards.length === 0) {
                return this.checkDraw() ? Winner.Draw : Winner.User
            }
            if (rivalCards.length === 0) {
                return this.checkDraw() ? Winner.Draw : Winner.Rival
            }
        }
        return Winner.None
    }

    private checkDraw(): boolean {
        let isDraw: boolean
        const {turn, trump, userCards, rivalCards} = this.state
        const attackCards = this.getNonOverlappingCards()
        const isUserMove = turn === Winner.User
        const protectionCards = isUserMove ? rivalCards : userCards
        console.groupCollapsed('Проверка ничьей')
        console.log(isUserMove ? 'Отбивается балда' : 'Отбивается  игрок')
        console.log('Карты отбивающегося:', protectionCards)
        console.log('Не битые карты:', attackCards)

        if (attackCards.length) {
            const attack = checkAttack(
                attackCards.map(getCardByKey),
                protectionCards.map(getCardByKey),
                getCardByKey(trump)
            )
            console.log('Не покрыть:', attack)
            isDraw = !attack && attackCards.length === protectionCards.length
        } else {
            isDraw = rivalCards.length + userCards.length === 0
        }
        console.log('Ничья:', isDraw)
        console.groupEnd()
        return isDraw
    }

    private playCompleteWin(winner: string): void {
        console.log('winner:', winner + '!!!')
        const ru: boolean = this.props.lang === 'ru'
        let message: string
        let button: string = ru ? 'Новая игра' : 'New Game'

        if (winner === Winner.User) {
            let rank = this.shoulderStraps()

            if (rank && ru) {
                message = Game.shoulderStrapsMessage(rank)
            } else {
                message = randomItem(
                    ru
                        ? ['Отличная игра. Сыграем еще?', 'Поздравляю с победой!', 'Может быть еще партейку?']
                        : ["Good game. Let's play again?", 'Congratulations on the victory!', 'Victory!']
                )
            }
        } else if (winner === Winner.Rival) {
            message = randomItem(
                ru
                    ? [
                          'В этот раз Балда победил.',
                          'Как на счёт реванша?',
                          'Может быть еще партейку?',
                          'Бывает. В следующий раз повезёт.',
                      ]
                    : ['This time "Balda" won.', 'How about a rematch?', 'It happens. Lucky next time.']
            )
            button = ru ? 'Играть еще' : 'Play more'
        } else {
            message = randomItem(ru ? ['Ничья.', 'Победила дружба.'] : ['Draw'])
        }
        this.confirm(confirmTypes.PLAY_YET, message, button)

        if (this.props.onComplete) {
            this.props.onComplete()
        }
    }

    // Погоны
    private shoulderStraps(): string {
        let ranks = this.state.battleCards.map(cards => DeckUtilInst.getCardByKey(cards[0]).rank)
        if (ranks.length === 2 && ranks[0] === ranks[1]) {
            console.log(ranks)
            return ranks[0]
        }
        return ''
    }

    private static shoulderStrapsMessage(rank: string): string {
        let messages: {[key: string]: string} = {
            '6': 'Две шестёрки',
            '7': 'Две семёрки',
            '8': 'Две восьмёрки',
            '9': 'Две девятки',
            '10': 'Две десятки',
            J: 'Два валета',
            Q: 'Две дамы',
            K: 'Два короля',
            A: 'Два туза',
        }
        if (messages[rank] && Math.random() > 0.3) {
            return `Ммм.. ${messages[rank]} на погоны? Неплохо!`
        } else {
            return 'Ммм.. Погоны? Неплохо!'
        }
    }

    private alignBattleCards() {
        let {width, height} = getCardSize()
        let {battleCards} = this.state
        let availableWidth = Math.min(1024, window.innerWidth) - 2 * width
        let maxWidth = availableWidth / battleCards.length
        let minWidth = Math.min(width, maxWidth)
        let top = window.innerHeight / 2 - height / 2

        battleCards.forEach((cards: string[], i: number) => {
            let left = (minWidth + 10) * i + Game.getLeftPadding()

            this.modifyCards(cards, (card: CardProps, _: string, __: number, n: number) => {
                return {
                    ...card,
                    left,
                    top: n === 0 ? top : top - 25,
                    flip: true,
                    active: false,
                    z: i * 2 + n,
                    rotate: n === 0 ? -15 : 25,
                    deck: false,
                }
            })
        })
    }

    private setStateAsync(state: object): Promise<any> {
        return new Promise(resolve => {
            this.setState(state, resolve)
        })
    }

    // Балда
    private async onMove(): Promise<void> {
        await this.timeout(500)

        if (!this.props.onMove) {
            return
        }
        let {userCards, rivalCards, battleCards} = this.state
        let {trump, turn, winner, offset} = this.state

        let move = this.props.onMove(
            rivalCards.map(getCardByKey),
            battleCards.map(cards => cards.map(getCardByKey)),
            getCardByKey(trump),
            turn,
            offset,
            userCards.length
        )
        if (move) {
            const {card, index} = move
            this.playCardSoundEffect()
            let battleCards = this.state.battleCards.slice()

            if (turn === Winner.Rival) {
                battleCards.push([card.key])
            } else {
                battleCards[index].push(card.key)
            }
            rivalCards = removeItem(rivalCards.slice(), card.key)

            const animatedKeys: string[] = []
            await this.setStateAsync({battleCards, rivalCards, animatedKeys})
            setImmediate(() => this.alignBattleCards())
            await this.timeout(25)
            this.checkWin()

            if (turn === Winner.Rival) {
                await this.timeout(1000)

                if (!winner) {
                    this.showGiveUpConfirm()
                }
            } else {
                await this.showOkConfirm()
            }
            // Ход не найден
        } else {
            if (turn === Winner.Rival) {
                if (this.countNonOverlappingCards() === 0) {
                    await this.timeout(1000)
                    await this.finishBattle()
                } else {
                    // Это не возможно пока карты бросаются по одной
                    this.showGiveUpConfirm()
                }
            } else {
                this.showRivalGiveUpConfirm()
            }
        }
    }

    private showRivalGiveUpConfirm(): void {
        let {rivalCards} = this.state
        const ru = this.props.lang === 'ru'

        if (this.ifUserCanAttack()) {
            if (this.countNonOverlappingCards() - rivalCards.length) {
                const msg = ru ? 'Я беру? Или добавите?' : 'I take? Or will you add more cards?'
                const btn = ru ? ['Подсказка', 'Бери!'] : ['Hint', 'Take!']
                this.confirm(confirmTypes.BALDA_TAKE_WITH_HINT, msg, btn)
            } else {
                const msg = randomItem(['Я беру?', 'Упс...'])
                const btn = ru ? ['Бери!'] : ['Take!']
                this.confirm(confirmTypes.BALDA_TAKE, msg, btn)
            }
        } else {
            const msg = ru ? 'Я беру? Кажется, вам нечего добавить.' : 'I take? It seems you have nothing to add.'
            const btn = ru ? 'Бери!' : 'Take!'
            this.confirm(confirmTypes.BALDA_TAKE, msg, btn)
        }
    }

    private async onConfirmRivalGiveUp(index: number): Promise<void> {
        if (index === 0 && this.state.confirm.type === confirmTypes.BALDA_TAKE_WITH_HINT) {
            this.attackHint()
            return
        }
        this.setState({animatedKeys: []})
        await this.hideConfirm()
        const cards = this.getBattleCards()
        this.giveBattleCards(cards, false).then(() => {})
    }

    private async showOkConfirm(): Promise<void> {
        const ru = this.props.lang === 'ru'
        if (this.ifUserCanAttack()) {
            const msg = ru ? 'Бито? Или еще добавите?' : 'Everything? Or add something else?'
            const btn = ru ? ['Подсказка', 'Бито!'] : ['Hint', 'Done!']
            this.confirm(confirmTypes.BEAT_WITH_HINT, msg, btn)
        } else {
            const msg = ru ? 'Кажется, вам нечего добавить.' : 'It seems you have nothing to add.'
            const btn = ru ? 'Бито!' : 'Done!'
            this.confirm(confirmTypes.BEAT, msg, btn)
        }
    }

    private async onConfirmBeatWithHint(index: number): Promise<void> {
        if (index === 0) {
            this.attackHint()
            return
        }
        this.setState({animatedKeys: []})
        await this.onConfirmBeat()
    }

    private attackHint(): void {
        console.groupCollapsed('Подсказка (атака)')
        const battle = this.getBattleCards()
        const ranks = battle.map(c => getCardByKey(c).rank)
        const animatedKeys = this.state.userCards.filter(c => ranks.indexOf(getCardByKey(c).rank) !== -1)
        console.log('ranks', ranks)
        console.log('animatedKeys', animatedKeys)
        this.setState({animatedKeys})
        console.groupEnd()
    }

    private async onConfirmBeat(): Promise<void> {
        await this.finishBattle()
        await this.timeout(1000)
        return this.onMove()
    }

    private async finishBattle(): Promise<void> {
        if (this.state.winner) {
            return
        }
        this.moveDisabled = true
        await this.hideConfirm()
        await this.removeBrokenCards()
        await this.giveMissingCards()
        await this.toggleTurn()
        this.moveDisabled = false

        if (process.env.NODE_ENV === 'development') {
            // @ts-ignore
            window.historyState.push(Object.assign({}, this.state))
            this.log()
        }
    }

    private async removeBrokenCards(): Promise<void> {
        const cardSize = getCardSize()
        const battleCards = this.getBattleCards()
        const cards = this.state.cards.slice(0)

        if (this.state.battleCards.length > 1) {
            let minLeft = 10e3

            for (let i = 0; i < battleCards.length; i++) {
                let index = getIndexByKey(battleCards[i])
                minLeft = Math.min(minLeft, cards[index].left || 0)
            }

            for (let i = 0; i < battleCards.length; i++) {
                let index = getIndexByKey(battleCards[i])
                cards[index].left = minLeft
                cards[index].rotate = random(-30, 30)
            }
            this.setState({cards})
            await this.timeout(800)
        }
        for (let i = 0; i < battleCards.length; i++) {
            let index = getIndexByKey(battleCards[i])
            cards[index].left = -cardSize.width * 2
        }
        await this.setStateAsync({cards})
    }

    private toggleTurn(): Promise<any> {
        const {turn} = this.state
        const {User, Rival} = Winner

        return this.setStateAsync({turn: turn === User ? Rival : User})
    }

    private ifUserCanAttack(): boolean {
        const cards = this.state.userCards
        const battleCards = this.getBattleCards()

        for (let j = 0; j < cards.length; j++) {
            let card = cards[j]

            for (let i = 0; i < battleCards.length; i++) {
                if (getCardByKey(card).rank === getCardByKey(battleCards[i]).rank) {
                    return true
                }
            }
        }
        return false
    }

    // Предложение взять карты
    private showGiveUpConfirm(timeout: number = 5000): void {
        let attackCards = this.getNonOverlappingCards()
        let userCards = this.state.userCards
        let trumpCard = this.state.trump
        let attack = checkAttack(attackCards.map(getCardByKey), userCards.map(getCardByKey), getCardByKey(trumpCard))
        if (attack) {
            timeout = 0
        }
        if (this.showGiveUpConfirmTID) {
            clearTimeout(this.showGiveUpConfirmTID)
        }
        this.showGiveUpConfirmTID = setTimeout(() => {
            if (this.state.turn === Winner.User) {
                return
            }
            let message, buttons

            if (this.props.lang === 'ru') {
                message = attack
                    ? randomItem([
                          'Вам не отбиться. Нужно брать.',
                          'Кажется крыть нечем. Нужно брать.',
                          'Хьюстон, у нас проблемы',
                      ])
                    : 'Можете взять, если не хотите крыть.'
                buttons = attack ? 'Берём' : ['Подсказка', 'Берём']
            } else {
                message = attack
                    ? randomItem(['You do not fight back. Need to take!', 'Houston, we have a problem.'])
                    : "You can take it if you don't want to beat this cards."
                buttons = attack ? 'Take' : ['Hint', 'Take']
            }
            this.confirm(confirmTypes.NEED_TAKE, message, buttons)
        }, timeout)
    }

    private async onConfirmUserGiveUp(index: number): Promise<void> {
        let {buttons} = this.state.confirm

        if (index === 0 && buttons && buttons.length === 2) {
            console.groupCollapsed('Подсказка')
            const {userCards, battleCards, trump} = this.state
            const cards = getProtectionCards(
                userCards.map(getCardByKey),
                battleCards.map(c => c.map(getCardByKey)),
                getCardByKey(trump)
            )
            const animatedKeys = cards.map(c => c.card.key)
            this.setState({animatedKeys})
            console.log('Карты для защиты:', animatedKeys)
            console.groupEnd()
            return
        }
        this.setState({animatedKeys: []})
        await this.hideConfirm()
        const cards = this.getBattleCards()
        await this.giveBattleCards(cards, true)
        await this.timeout(1000)
        await this.onMove()
    }

    private async giveBattleCards(battleCards: string[], isUser: boolean = false): Promise<void> {
        let allCards = this.state.cards.slice(0)
        for (let i = 0; i < battleCards.length; i++) {
            let key = battleCards[i]
            let index = getIndexByKey(key)
            allCards[index].active = isUser
        }
        if (isUser) {
            let userCards = this.state.userCards.slice(0).concat(battleCards)
            this.setState({userCards})
        } else {
            let rivalCards = this.state.rivalCards.slice(0).concat(battleCards)
            this.setState({rivalCards})
        }
        this.setState({cards: allCards}, async () => {
            await this.giveMissingCards()
            await this.timeout(500)
            this.log()

            if (isUser) {
                await this.alignUserCards(this.state.userCards)
            } else {
                await this.alignBaldaCards(this.state.rivalCards)
            }
        })
    }

    private async giveMissingCards(): Promise<void> {
        let {turn} = this.state

        if (turn === Winner.User) {
            await this.giveMissingUserCards()
            await this.timeout(500)
            await this.giveMissingRivalCards()
        } else {
            await this.giveMissingRivalCards()
            await this.timeout(500)
            await this.giveMissingUserCards()
        }
        await this.setStateAsync({battleCards: []})
        this.checkWin()
        // Подравниваем колоду
        this.alignDeck()
    }

    private alignDeck(): void {
        let {offset} = this.state
        this.moveDeckToRight(offset)
        if (offset < 36) this.handOverTrump()
    }

    private async giveMissingUserCards(): Promise<void> {
        return new Promise(async resolve => {
            const {userCards, offset} = this.state

            if (userCards.length < 6) {
                const limit = 6 - userCards.length
                const cards = await this.getMissingCards(limit, offset)

                this.setState(
                    {
                        offset: offset + cards.length,
                        userCards: userCards.slice(0).concat(cards),
                    },
                    () => {
                        const {userCards} = this.state
                        this.alignUserCards(userCards, cards)
                        resolve()
                    }
                )
            } else {
                this.alignUserCards(userCards)
                resolve()
            }
        })
    }

    private async giveMissingRivalCards(): Promise<void> {
        return new Promise(async resolve => {
            const {rivalCards, offset} = this.state

            if (rivalCards.length < 6) {
                const limit = 6 - rivalCards.length
                const cards = await this.getMissingCards(limit, offset)

                this.setState(
                    {
                        offset: this.state.offset + cards.length,
                        rivalCards: rivalCards.slice(0).concat(cards),
                    },
                    () => {
                        this.alignBaldaCards(this.state.rivalCards, cards)
                        resolve()
                    }
                )
            } else {
                this.alignBaldaCards(this.state.rivalCards)
                resolve()
            }
        })
    }

    private async getMissingCards(limit: number, offset: number): Promise<string[]> {
        let missingCards: string[] = []
        let cards = this.state.cards.slice(0)

        for (let i = offset; i < offset + limit; i++) {
            if (cards[i]) {
                missingCards.push(cards[i].key)
            } else {
                break
            }
        }
        return missingCards
    }

    private confirm(type: confirmTypes, message: string, btnMessage: string | string[]): void {
        if (this.state.winner && type !== confirmTypes.PLAY_YET) {
            return
        }
        let buttons = Array.isArray(btnMessage) ? btnMessage : [btnMessage]
        let confirm = {type, message, buttons}
        this.setState({confirm})
    }

    private hideConfirm(): Promise<void> {
        let confirm = {type: this.state.confirm.type}

        return new Promise(resolve => {
            if (this.props.onCloseConfirm) {
                this.props.onCloseConfirm((wasShown: any) => {
                    this.setState({confirm})
                    setTimeout(() => resolve(), wasShown ? 500 : 1)
                })
            } else {
                this.setState({confirm})
                resolve()
            }
        })
    }

    private async onConfirm(index: number): Promise<void> {
        if (!this.props.mute) {
            playClickSound()
            await this.timeout(200)
        }
        let {type} = this.state.confirm

        if (type === confirmTypes.BEAT) {
            await this.onConfirmBeat()
        } else if (type === confirmTypes.BEAT_WITH_HINT) {
            await this.onConfirmBeatWithHint(index)
        } else if (type === confirmTypes.BALDA_TAKE || type === confirmTypes.BALDA_TAKE_WITH_HINT) {
            await this.onConfirmRivalGiveUp(index)
        } else if (type === confirmTypes.NEED_TAKE) {
            await this.onConfirmUserGiveUp(index)
        } else if (type === confirmTypes.PLAY_YET) {
            await this.newGame()
        } else {
            console.log('Unknown confirm type')
        }
    }

    // Возвращает не покрытые карты на столе
    private getNonOverlappingCards(): string[] {
        const {battleCards} = this.state
        let cards: string[] = []

        if (battleCards.length) {
            for (let i = 0; i < battleCards.length; i++) {
                if (battleCards[i].length === 1) {
                    cards.push(battleCards[i][0])
                }
            }
        }
        return cards
    }

    private sortCardsByWeight(cards: string[]): string[] {
        let {trump} = this.state

        cards.sort((a, b) => {
            let aw = DeckUtilInst.getWeight(a, trump)
            let bw = DeckUtilInst.getWeight(b, trump)
            return aw - bw
        })
        return cards
    }

    // Возвращает TRUE если карта такого ранга есть на поле
    private checkCard(key: string, opponentCards: string[]): boolean {
        if (this.countNonOverlappingCards() + 1 > opponentCards.length) {
            return false
        }
        if (this.state.battleCards.length) {
            const battleCards = this.getBattleCards()

            for (let i = 0; i < battleCards.length; i++) {
                if (getCardByKey(key).rank === getCardByKey(battleCards[i]).rank) {
                    return true
                }
            }
            return false
        }
        return true
    }

    private getBattleCards(): string[] {
        return concat(this.state.battleCards)
    }

    private countNonOverlappingCards(): number {
        const {battleCards} = this.state
        let counter: number = 0

        if (battleCards.length) {
            for (let i = 0; i < battleCards.length; i++) {
                if (battleCards[i].length === 1) {
                    counter++
                }
            }
        }
        return counter
    }

    private async timeout(timeout: number = 1000): Promise<void> {
        if (!FAST_MODE) return new Promise(resolve => setTimeout(resolve, timeout))
    }

    private params(params: object | string): void {
        const {onVisitParams} = this.props
        if (onVisitParams) onVisitParams(params)
    }

    private static getGameStarter(userCards: string[], rivalCards: string[], trump: string): Winner {
        const trumpCard = getCardByKey(trump)
        const userTrump = getMinTrump(userCards.map(getCardByKey), trumpCard)
        const rivalTrump = getMinTrump(rivalCards.map(getCardByKey), trumpCard)

        if (userTrump && rivalTrump) {
            return compareCards(userTrump, rivalTrump, trumpCard) ? Winner.User : Winner.Rival
        }
        if (!userTrump && rivalTrump) {
            return Winner.Rival
        }
        if (userTrump && !rivalTrump) {
            return Winner.User
        }
        return Math.random() > 0.5 ? Winner.User : Winner.Rival
    }

    private static getMaxWidth(): number {
        return Math.min(window.innerWidth, 1000)
    }

    private static getLeftPadding(countCards: number = 0): number {
        if (countCards && countCards > 10) return 10
        if (window.innerWidth > 1000) return (window.innerWidth - 1000) / 2
        return 10
    }

    private playCardSoundEffect = (): void => {
        if (!FAST_MODE && !this.props.mute) {
            playCardSoundEffect()
        }
    }

    private playSlideSoundEffect = debounce((): void => {
        if (!FAST_MODE && !this.props.mute) {
            playSlideSoundEffect()
        }
    }, 100)
}
